import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { SUPERADMIN_PATH, ADMIN_PATH } from "@/App";

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) {
    const login = role === "superadmin" ? SUPERADMIN_PATH : role === "admin" ? ADMIN_PATH : "/login";
    return <Navigate to={login} replace />;
  }
  if (role && user.role !== role) {
    const home = user.role === "superadmin" ? "/superadmin" : user.role === "admin" ? "/admin" : "/app";
    return <Navigate to={home} replace />;
  }
  return children;
}
